export const header = (): void => {
  const burgerButton: HTMLElement | null = document.querySelector('.l-header__burger');
  const nav: HTMLElement | null = document.querySelector('.l-header__nav');
  const header: HTMLElement | null = document.querySelector('.l-header');

  const navItems: NodeListOf<HTMLElement> = document.querySelectorAll('.l-header__nav-list > li');
  const megaMenu: HTMLElement | null = document.querySelector('.p-mega-nav');

  if (burgerButton) {
    burgerButton.addEventListener('click', () => {
      burgerButton.classList.toggle('is-open');
      nav?.classList.toggle('is-active');
      if (megaMenu?.classList.contains('is-active')) {
        megaMenu.classList.remove('is-active');
      }
    });
  }

  addEventListener('scroll', () => {
    const scrollY: number = window.scrollY;
    if (scrollY > 0) {
      header?.classList.add('is-scrolled');
    } else {
      header?.classList.remove('is-scrolled');
    }
  });
  navItems.forEach((item: HTMLElement) => {
    const link: HTMLElement | null = item.querySelector('& > a');
    const subMenu: HTMLElement | null = item.querySelector('& > .sub-menu');

    // PCのみ
    if (window.matchMedia( "(min-width: 768px)" ).matches) {
      link?.addEventListener('click', (e: Event): void => {
        // サブメニューが存在する場合、メガメニューを表示
        if (subMenu && megaMenu) {
          e.preventDefault();
          if (link?.classList.contains('is-active')) {
            link?.classList.remove('is-active');
            megaMenu?.classList.remove('is-active');
            return;
          } else {
            navItems.forEach((item: HTMLElement) => {
              item.querySelector('a')?.classList.remove('is-active');
            });
            link?.classList.add('is-active');
          }
          if (item.classList.contains('is-icon')) {
            megaMenu.style.top = '9rem';
          } else {
            megaMenu.style.top = '10.8rem';
          }
          megaMenu.classList.add('is-active');

          // 親リンクのリンク先を取得
          let parentLinkHref: string = '';
          if (e.target instanceof HTMLElement) {
            parentLinkHref = e.target.getAttribute('href') || '';
          }

          const parentLink: HTMLElement | null = megaMenu.querySelector('.p-mega-nav__heading');
          const subMenuEn: HTMLElement | null = megaMenu.querySelector('.p-mega-nav__en');
          const subMenuJp: HTMLElement | null = megaMenu.querySelector('.p-mega-nav__title');
          const subMenuList: HTMLElement | null = megaMenu.querySelector('.p-mega-nav__list');

          // メニューを空にする
          if (subMenuList) {
            subMenuList.innerHTML = '';
          }

          // 親リンクを反映
          parentLink?.setAttribute('href', parentLinkHref);

          // サブメニューのヘディングを反映
          if (subMenuEn) {
            subMenuEn.textContent = link?.querySelector('.en')?.textContent || '';
          }
          if (subMenuJp) {
            subMenuJp.textContent = link?.querySelector('.ja')?.textContent || '';
          }

          // subMenuList の中に subMenu をクローンして代入
          const cloneSubMenu: HTMLElement = subMenu.cloneNode(true) as HTMLElement;
          subMenuList?.appendChild(cloneSubMenu);
        }
      });

      window.addEventListener('scroll', () => {
        if (megaMenu?.classList.contains('is-active')) {
          megaMenu.classList.remove('is-active');
        }
        link?.classList.remove('is-active');
      });
    } else {
      // SPのみ
      link?.addEventListener('click', (e: Event): void => {
        const target: HTMLElement | null = e.target as HTMLElement;
        if (target.classList.contains('show-child')) {
          e.preventDefault();
          target.classList.toggle('is-active');
          const parentLink: HTMLElement | null = target.closest('a');
          const childMenu: HTMLElement | null = parentLink?.nextElementSibling as HTMLElement;
          childMenu.classList.toggle('is-active');
        }

        if (target.classList.contains('show-mega')) {
          e.preventDefault();
          megaMenu?.classList.add('is-active');

          if (subMenu && megaMenu) {
            // 親リンクのリンク先を取得
            const parentLinkHref: string = target.closest('a')?.getAttribute('href') || '';

            const parentLink: HTMLElement | null = megaMenu.querySelector('.p-mega-nav__heading');
            console.log(parentLink, target);
            const subMenuEn: HTMLElement | null = megaMenu.querySelector('.p-mega-nav__en');
            const subMenuJp: HTMLElement | null = megaMenu.querySelector('.p-mega-nav__title');
            const subMenuList: HTMLElement | null = megaMenu.querySelector('.p-mega-nav__list');

            // メニューを空にする
            if (subMenuList) {
              subMenuList.innerHTML = '';
            }

            // 親リンクを反映
            parentLink?.setAttribute('href', parentLinkHref);

            // サブメニューのヘディングを反映
            if (subMenuEn) {
              subMenuEn.textContent = link?.querySelector('.en')?.textContent || '';
            }
            if (subMenuJp) {
              subMenuJp.textContent = link?.querySelector('.ja')?.textContent || '';
            }

            // subMenuList の中に subMenu をクローンして代入
            const cloneSubMenu: HTMLElement = subMenu.cloneNode(true) as HTMLElement;
            subMenuList?.appendChild(cloneSubMenu);
          }
        }
      });
    }

    const megaClose: HTMLElement | null = document.querySelector('.p-mega-nav__footer-link');
    megaClose?.addEventListener('click', (): void => {
      megaMenu?.classList.remove('is-active');
    });
  });
};
